import 'slick-carousel';
import $ from 'jquery';

function resolveSpriteUrl() {
  const fromLayout = document.querySelector('[data-sprite-url]')?.getAttribute('data-sprite-url');
  if (fromLayout) {
    return fromLayout;
  }

  const logoUse = document.querySelector('.header .icon-logo use, .logo use');
  const href = logoUse?.getAttribute('href')
    || logoUse?.getAttributeNS('http://www.w3.org/1999/xlink', 'href')
    || '';

  return href.split('#')[0];
}

$(window).on('load', () => {
  const spriteUrl = resolveSpriteUrl();
  var prevArrow = `<div class="slider__arrow slider__arrow_prev"><svg class="icon icon-arrow-left"><use href="${spriteUrl}#icon-arrow-left" xlink:href="${spriteUrl}#icon-arrow-left"></use></svg></div>`;
  var nextArrow = `<div class="slider__arrow slider__arrow_next"><svg class="icon icon-arrow-right"><use href="${spriteUrl}#icon-arrow-right" xlink:href="${spriteUrl}#icon-arrow-right"></use></svg></div>`;


  $('.slider.js-slide').each((index, item) => {
    $(
      item
    ).slick({
      dots: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      dotsClass: 'slider__dotts'
    });
  });

  $('.slider.js-fade').each((index, item) => {
    $(
      item
    ).slick({
      dots: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      dotsClass: 'slider__dotts',
      fade: true,
      speed: 0,
    });
  });
});
